export const infrastructureArchitectureDiagramFixedCacheKey =
  "c8r-get-infrastructure-architecture-diagram-fixed-cache-key";

export const infrastructureArchitectureRecommendationFixedCacheKey =
  "c8r-get-infrastructure-architecture-recommendation-fixed-cache-key";

export const infrastructureArchitectureStatePreferenceKey =
  "c8r-solution-architect-state";
